export default {
  CREATE: {
    TITLE: `Create an availability request`,
    SUMMARY: ``
  },
  EDIT: {
    TITLE: `Edit an availability request`,
    SUMMARY: ``
  },
  VIEW: {
    TITLE: `View an availability request`,
    SUMMARY: ``
  },
  DATEVALID: {
    LABEL: `Start Date`,
    PLACEHOLDER: ``,
    DESCRIPTION: `The start date must be later than {{minimumDate}} and cannot be the same date as another availability.`,
    TEMPORARY_DESCRIPTION: `This date must not be in the past.`
  },
  DATEEXPIRED: {
    LABEL: `End Date`,
    PLACEHOLDER: ``,
    DESCRIPTION: `This date must not be in the past and must be at least a week after the start date.`
  },
  NOTES: {
    LABEL: `Notes`,
    PLACEHOLDER: ``,
    DESCRIPTION: `Enter notes or additional information for your manager.`
  },
  TEMPORARY: {
    LABEL: `Set an end date`,
    DESCRIPTION: ``
  },
  REGULAR: {
    LABEL: `Repeats indefinitely`,
    DESCRIPTION: `This availability will repeat itself until the next availability starts.`
  },
  COPY_MODAL: {
    TITLE: `Copy/Paste Day`,
    PRIMARY_ACTION: `Apply`,
    SUMMARY: ``
  },
  AVAILABILITYSTART: {
    LABEL: ``,
    DESCRIPTION: ``,
    PLACEHOLDER: ``
  },
  AVAILABILITYEND: {
    LABEL: ``,
    DESCRIPTION: ``,
    PLACEHOLDER: ``
  },
  UNMATCHED_AVAILABILITIES_WARNING: `The following availabilities cannot be changed, please contact your manager to change them`,
  NOTAVAILABLE: { OPTIONS: { true: { LABEL: `Not available`, DESCRIPTION: `` }, false: { LABEL: `Available`, DESCRIPTION: `` } } },
  ADD_RANGE: `Specify range`,
  ADD_ANOTHER_RANGE: `Add another range`,
  SET_AVAILABLE: `Mark as available`,
  SET_UNAVAILABLE: `Mark as unavailable`,
  SET_PREFERRED: `Mark as preferred`,
  NOTES_REQUIRED: `The notes field is mandatory.`,
  START_DATE_AFTER_TODAY: `The start date must be a future date.`,
  START_DATE_CUTOFF_ERROR: `The start date must be later than {{minimumDate}}.`,
  START_DATE_UNIQUE: `The start date must not be the same as any other availability start date.`,
  START_DATE_REQUIRED: `The start date field is mandatory.`,
  END_DATE_REQUIRED: `The end date field is mandatory.`,
  END_DATE_AFTER_START: `The end date must be at least a week after the start date.`,
  AVAILABLE_ALL_DAY: `Available`,
  UNAVAILABLE_ALL_DAY: `Unavailable`,
  UNAVAILABLE_FROM: `I'm unavailable from`,
  UNAVAILABLE: `Unavailable`,
  AVAILABLE: `Available`,
  PREFERRED: `Preferred`,
  APPROVAL_REQUIRED_MESSAGE: `Your manager must approve this availability before it becomes active.`,
  CHANGES_REQUESTED_MESSAGE: `Your manager has requested that you change this availability before it becomes active.`,
  NOTE_FROM_MANAGER: `Note from your manager:`,
  NONE: `None`,
  COPY_TO_FOLLOWING: `Your availability for {{ day }} will be copied to the following day(s):`
}
